import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import Dashboard from './pages/Dashboard'
import RegisterUser from './pages/RegisterUser'
import Login from './pages/Login'
import ResponsiveAppBar from './components/AppBar'
import ForgotPass from './pages/ForgotPass'
import { useAuthContext } from './hooks/useAuthContext'
import HomePage from './pages/HomePage'
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { lime, purple } from '@mui/material/colors';
import Sessions from './pages/Sessions'
import CodeofConduct from './pages/CodeofConduct'
import Services from './pages/Services'
import CIERules from './pages/CIERules'
import CamDash from './pages/auth/cambridge/CamDash'
import CamApply from './pages/auth/cambridge/CamApply'
import CamEntryStatus from './pages/auth/cambridge/CamEntryStatus'
import CamReturn from './pages/auth/cambridge/CamReturn'
import BookConsult from './pages/auth/consult/BookConsult'
import ConsultReturn from './pages/auth/consult/ConsultReturn'
import Terms from './pages/Terms'
function App() {




  const theme = createTheme({
    palette: {
      primary: {
        main: '#2b3a42'

      },
      secondary: {
        main: '#e91e63'
      },
    },

  });

  const { user,
    authIsReady,
    accessLevel,
    studentID
  } = useAuthContext()




  return (
    <>

      {
        authIsReady && (
          <ThemeProvider theme={theme}>

            <BrowserRouter>
              {user && (<ResponsiveAppBar />)}
              <Routes>

                <Route path="/" element={studentID ? <Dashboard /> : <HomePage />} />
                <Route path="/login" element={studentID ? <Navigate to="/" /> : <Login />} />
                <Route path="/forgotpassword" element={studentID ? <Navigate to="/" /> : <ForgotPass />} />
                <Route path="/register" element={studentID ? <Navigate to="/" /> : <RegisterUser />} />

                <Route path="/info" element={studentID ? <Services /> : <Services />} />


                <Route path="/tnc" element={studentID ? <Terms /> : <Terms />} />
                <Route path="/terms" element={studentID ? <Terms /> : <Terms />} />
                <Route path="/sessions" element={studentID ? <Sessions /> : <Sessions />} />
                <Route path="/conduct" element={<CodeofConduct />} />
                <Route path="/cierules" element={<CIERules />} />

                <Route path="/cambridge" element={studentID ? <Dashboard /> : <Login />} />
                <Route path="/cambridge/apply" element={studentID ? <CamApply /> : <Login />} />
                <Route path="/cambridge/status" element={studentID ? <CamEntryStatus /> : <Login />} />
                <Route path="/cambridge/return/:id" element={authIsReady ? <CamReturn /> : <Navigate to="/" />} />
                {/* <Route path="/pCamDashaymentreturn/:id" element={user ? <PaymentReturn /> : <Navigate to="/" />} /> */}
                <Route path="/consult/book" element={studentID ? <BookConsult /> : <Login />} />
                <Route path="/consult/return/:id" element={authIsReady ? <ConsultReturn /> : <Navigate to="/" />} />
              </Routes>
            </BrowserRouter>
          </ThemeProvider>
        )
      }

    </>
  );
}

export default App;
